import { jsx as _jsx } from "react/jsx-runtime";
export const Minimize = ({ size = 24, color = 'currentColor' }) => {
    return (_jsx("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { stroke: color, strokeWidth: "1.5", strokeLinecap: "round", d: "M4.75 18.25h14.5" }) }));
};
